import React from 'react'
import PropTypes from 'prop-types'
import { CardStyle, NameStyle, JobTitleStyle } from './styled';

const Card = ({ name, job, image, leaderStyle }) => {
  const altText = image.alt || "";

  return (
    <CardStyle style={{display: 'flex', flexDirection: 'row'}}>
      <img 
        src={image.url} 
        width={image.dimensions.width}
        height={image.dimensions.height}
        alt={altText}
      />
      <section style={{paddingLeft:'0.8em', paddingTop: '30px'}}>
        <NameStyle leaderStyle={leaderStyle}>{name}</NameStyle>
        <JobTitleStyle leaderStyle={leaderStyle}>{job}</JobTitleStyle>
      </section>

    </CardStyle>
  )
}

Card.propTypes = {
  image: PropTypes.object,
  job: PropTypes.string,
  leaderStyle: PropTypes.bool,
  name: PropTypes.string
}

export default Card
